import { PhoneCall, MessageCircle, Mail, Users, Building2, FileText, PhoneOutgoing, PhoneIncoming, PhoneMissed } from 'lucide-react';

export const LEAD_SOURCES = [
  { value: 'website', label: 'Website' },
  { value: 'referral', label: 'Referral' },
  { value: 'walk_in', label: 'Walk-in' },
  { value: 'social_media', label: 'Social Media' },
  { value: 'property_portal', label: 'Property Portal' },
  { value: 'cold_call', label: 'Cold Call' },
  { value: 'newspaper', label: 'Newspaper Ad' },
  { value: 'hoarding', label: 'Hoarding/Billboard' },
  { value: 'sms_campaign', label: 'SMS Campaign' },
  { value: 'email_campaign', label: 'Email Campaign' },
  { value: 'partner', label: 'Channel Partner' },
  { value: 'other', label: 'Other' },
];

export const PAIN_POINTS = [
  'Budget constraints',
  'Location preference',
  'Timeline urgency',
  'Loan approval concerns',
  'Property size requirements',
  'Amenities requirements',
  'Resale value concerns',
  'Documentation issues',
  'Family approval pending',
  'Comparing with competitors'
];

export const LIFE_EVENTS = [
  'New job',
  'Job transfer',
  'Marriage',
  'New baby',
  'Children education',
  'Retirement',
  'Investment purpose',
  'Upgrade from current home',
  'First home buyer',
  'NRI investment'
];

export const ACTIVITY_TYPES = [
  { value: 'call', label: 'Phone Call', icon: PhoneCall },
  { value: 'whatsapp', label: 'WhatsApp', icon: MessageCircle },
  { value: 'email', label: 'Email', icon: Mail },
  { value: 'meeting', label: 'Meeting', icon: Users },
  { value: 'site_visit', label: 'Site Visit', icon: Building2 },
  { value: 'note', label: 'Note', icon: FileText },
];

export const CALL_TYPES = [
  { value: 'outgoing', label: 'Outgoing Call', icon: PhoneOutgoing },
  { value: 'incoming', label: 'Incoming Call', icon: PhoneIncoming },
  { value: 'missed', label: 'Missed Call', icon: PhoneMissed },
];

export const REMINDER_TYPES = [
  { value: 'follow_up', label: 'Follow Up' },
  { value: 'callback', label: 'Callback' },
  { value: 'site_visit', label: 'Site Visit' },
  { value: 'document', label: 'Document Collection' },
  { value: 'payment', label: 'Payment Reminder' },
];

export const PRIORITY_OPTIONS = [
  { value: 'low', label: 'Low', color: 'bg-gray-100 text-gray-600' },
  { value: 'medium', label: 'Medium', color: 'bg-blue-100 text-blue-700' },
  { value: 'high', label: 'High', color: 'bg-amber-100 text-amber-700' },
  { value: 'urgent', label: 'Urgent', color: 'bg-red-100 text-red-700' },
];

export const DEFAULT_STAGE_COLORS = [
  '#3b82f6', '#06b6d4', '#10b981', '#f59e0b', '#8b5cf6', '#22c55e', '#ef4444',
  '#ec4899', '#14b8a6', '#f97316'
];
